import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import { honorsAndAwards } from '../../data/portfolioData';
import CardSpotlight from '../CardSpotlight/CardSpotlight';
import styles from './Honors.module.css';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const Honors = () => {
  // Duplicate array for infinite scroll effect
  const duplicatedAwards = [...honorsAndAwards, ...honorsAndAwards];

  return (
    <section id="honors" className={styles.honorsSection}>
      <div className={styles.container}>
        <motion.div 
          className={styles.sectionHeader}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUpVariants}
        >
          <h2 className={styles.title}>Honors & Awards</h2>
          <div className={styles.line}></div>
        </motion.div>

        <motion.div 
          className={styles.marqueeContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUpVariants}
        >
          <div 
            className={styles.marqueeTrack}
            style={{ 
              animationDuration: `${Math.max(honorsAndAwards.length * 5, 40)}s`,
            }}
          >
            {duplicatedAwards.map((award, index) => (
              <div 
                key={`${award.title}-${index}`} 
                className={styles.card}
              >
                <CardSpotlight style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div className={styles.cardContent}>
                    <div className={styles.issuer}>{award.issuer}</div>
                    <h3 className={styles.awardTitle}>{award.title}</h3>
                    <div className={styles.date}>{award.date}</div>
                    
                    <div className={styles.actions}>
                      <a 
                        href={award.url} 
                        target="_blank" 
                        rel="noreferrer" 
                        className={styles.btnLink}
                      >
                        View <FiExternalLink size={16} />
                      </a>
                    </div>
                  </div>
                </CardSpotlight>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Honors;
